// frontend/src/visitor_ai/components/ActionConfirmBox.jsx
import React from "react";

/**
 * ActionConfirmBox
 * - actionSchema: { action_type, params, confirm_required }
 * - onConfirm(), onCancel()
 */

const ActionConfirmBox = ({ actionSchema, onConfirm, onCancel }) => {
  if (!actionSchema) return null;
  return (
    <div className="visitor-ai-action-confirm">
      <h4>Confirm: {actionSchema.action_type}</h4>
      <div className="visitor-ai-action-params">
        <pre>{JSON.stringify(actionSchema.params || {}, null, 2)}</pre>
      </div>
      <div className="visitor-ai-action-buttons">
        <button className="confirm" onClick={onConfirm}>Confirm</button>
        <button className="cancel" onClick={onCancel}>Cancel</button>
      </div>
    </div>
  );
};

export default ActionConfirmBox;
